/**
 * Room trait module
 * 
 * Exports both the trait and behavior for rooms.
 * Rooms are special entities that represent locations in the game world.
 */

export { RoomTrait, IExitInfo } from './roomTrait';
export { RoomBehavior } from './roomBehavior';
